import React, { Component } from "react";
import PropTypes from "prop-types";

class ChatInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: ""
    };
    this.onChange = this.onChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  componentWillReceiveProps(prevProps) {
    if (this.state.value !== prevProps.value) {
      this.setState({
        value: prevProps.value
      });
    }
  }

  onChange(event) {
    this.props.onChange(event.target.value);
    this.setState({
      value: event.target.value
    });
  }

  onKeyPress(event) {
    if (event.key === "Enter") {
      this.props.onSubmit(event.target.value);
    }
  }

  render() {
    return /*#__PURE__*/React.createElement("input", {
      type: "text",
      placeholder: "Type a message...",
      value: this.state.value || "",
      maxLength: 256,
      onFocus: this.props.onFocus,
      onBlur: this.props.onBlur,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      disabled: this.props.disabled
    });
  }

}

ChatInput.propTypes = {
  value: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  disabled: PropTypes.bool
};
export default ChatInput;